import { component } from 'picoapp';
import Swiper, { Navigation, Thumbs, Keyboard } from 'swiper';
import Modal from 'utils/modal';

export default component((node: HTMLElement) => {
  const slider: HTMLElement = node.querySelector('[data-slider]');
  const prev: HTMLButtonElement = node.querySelector('[data-prev]');
  const next: HTMLButtonElement = node.querySelector('[data-next]');
  const thumbs: HTMLElement = node.querySelector('[data-thumbs]');

  const modal = Modal(node, node.parentElement);

  const triggers: NodeListOf<HTMLButtonElement> = document.querySelectorAll('[data-trigger="lightbox"]');
  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const { key } = trigger.dataset;
      if (node.id === key) modal.open();
    });
  });

  const thumbsSlider = new Swiper(thumbs, {
    slidesPerView: 12,
    spaceBetween: 15,
    watchSlidesProgress: true,
  });

  // eslint-disable-next-line no-new
  new Swiper(slider, {
    modules: [Navigation, Thumbs, Keyboard],
    navigation: {
      prevEl: prev,
      nextEl: next,
    },
    keyboard: {
      enabled: true,
    },
    slidesPerView: 1,
    spaceBetween: 1,
    thumbs: {
      swiper: thumbsSlider,
    },
  });
});
